/**
 * Test IDs for QA automation.
 */
export const testIds = {
  dataGridCustomToolbarColumns: "data-grid-custom-toolbar-columns",
  dataGridCustomToolbarQuickFilter: "data-grid-custom-toolbar-quick-filter",
  dataGridCustomToolbarExport: "data-grid-custom-toolbar-export",
  dataGridCustomToolbarDownloadAsCsv: "data-grid-custom-toolbar-download-as-csv",
  dataGridCustomToolbarPrint: "data-grid-custom-toolbar-print",
} as const;
